import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import {  ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS,HttpClientModule } from '@angular/common/http';
import { UnauthenticationHandlerComponent } from './components/authentication/unauthentication-handler.component';
import { HeaderComponent } from './sharedComponents/header/header.component';
import { MenuComponent } from './sharedComponents/menu/menu.component';
import { PolicyComponent } from './component/policy/policy.component';
import { CancelPolicyPopUp } from './component/policy/cancel-policy-popup/cancel-policy-popup.component';
import { SearchComponent } from './component/search/search.component';
import { SearchResultsComponent } from './component/search-results/search-results.component';
import { ClientDataComponent } from './component/policy/client-data/client-data.component';
import { ClaimComponent } from './component/policy/claims/claims.component';
import { PolicyDetailsComponent } from './component/policy/policy-details/policy-details.component';
import { EvidenceOfInsuranceComponent } from './component/policy/evidence-of-insurance/evidence-of-insurance.component';
import { CommonService } from './services/commonService';
import { Settings } from './services/settings';
import {ServiceLayer} from './services/serviceLayer';
import { DAO } from './modal/DAO';
import { FormsModule } from '@angular/forms';
import { PoliciesComponent } from './component/search/policies/policies.component';
import { QuotesComponent } from './component/search/quotes/quotes.component';
import { LoginComponent } from './component/Login/login.component';
import { OverviewComponent } from './component/overview/overview.component';
import { LandingComponent } from './component/landing/landing.component';
import { PolicyquotesComponent } from './component/policyQuotes/policyQuotes.component';
import { Table, TableModule } from 'primeng/table';
import { DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {CalendarModule} from 'primeng/calendar';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { DatePipe } from '@angular/common';
import {InputSwitchModule} from 'primeng/inputswitch';
import { FooterComponent } from './sharedComponents/footer/footer.component';
import {PaginatorModule} from 'primeng/paginator';
import {TabViewModule} from 'primeng/tabview';
import {DialogModule} from 'primeng/dialog';
import { AutocompleteComponent } from './googlePlaces.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputMaskModule} from 'primeng/inputmask';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {MultiSelectModule} from 'primeng/multiselect';
import {ProgressBarModule} from 'primeng/progressbar';
import {ToastModule} from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { ReportClaimComponent } from './component/policy/report-claim/report-claim.component';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { MaintenanceComponent } from './component/maintenance/maintenance.component';
import { NotificationBannerComponent } from './sharedComponents/notification-banner/notification-banner.component';
import { AuthenticationService } from './services/authentication.service';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
@NgModule({
  declarations: [
    AppComponent,
    UnauthenticationHandlerComponent,
    HeaderComponent,
    MenuComponent,
    PolicyComponent,
    ClientDataComponent,
    ClaimComponent,
    EvidenceOfInsuranceComponent,
    PolicyDetailsComponent,
    SearchComponent,
    SearchResultsComponent,
    CancelPolicyPopUp,
    PoliciesComponent,
    QuotesComponent,
    LoginComponent,
    OverviewComponent,
    LandingComponent,
    PolicyquotesComponent,
    FooterComponent,
    AutocompleteComponent,
    ReportClaimComponent,
    MaintenanceComponent,
    NotificationBannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule   ,
    TableModule  ,
    DropdownModule ,
    RadioButtonModule ,
    CalendarModule,
    ButtonModule,
    CheckboxModule ,
    BrowserAnimationsModule,
    AutoCompleteModule,
    InputSwitchModule,
    PaginatorModule,
    TabViewModule,
    DialogModule,
    ReactiveFormsModule,
    InputNumberModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ProgressBarModule,
    ToastModule,
    TooltipModule,
    FileUploadModule,
    InputMaskModule,
    InputTextareaModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri:  environment.auth0.authorizationParams.redirect_uri,
        organization : environment.auth0.authorizationParams.organization,
        audience : environment.auth0.authorizationParams.audience
      }
    })
  ],
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: AuthorizeHeaderInterceptor, multi: true },
{
    provide: CommonService,
    //useValue: undefined,
},
    Settings,
    ServiceLayer,
    AppComponent,
    DatePipe,
    DAO,
    MenuComponent,
    LandingComponent,
    AutocompleteComponent,
    ConfirmationService,
    AuthenticationService
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
